import { render, staticRenderFns } from "./LossReportViewer.vue?vue&type=template&id=0a1a6514"
import script from "./LossReportViewer.vue?vue&type=script&lang=ts"
export * from "./LossReportViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports